import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper, StyledPagination } from "@framework/styled";
import { ILotteryToken } from "@framework/types";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { decodeNumbers, decodeNumbersToArr, getWinners } from "../utils";
import { LotteryTokenDialogView } from "./view";
import { LotteryTokenSearchForm } from "./search";

const LOTTERY_TICKETS_TOKENS_URL = "/lottery/ticket/tokens";
const LOTTERY_TICKETS_TOKENS_DIALOG_KEY = "lotteryTicketTokens";

export const LotteryTicketTokens = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<ILotteryToken>
  >(LOTTERY_TICKETS_TOKENS_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<ILotteryToken>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "lottery", "lottery.tokens"]} />

      <PageHeader message="pages.lottery.tokens.title" />

      <LotteryTokenSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <StyledListItem key={token.id}>
              <List.ItemText sx={{ width: 0.2 }}>{token.id}</List.ItemText>
              <List.ItemText sx={{ width: 0.3 }}>{decodeNumbers(token.metadata.NUMBERS)}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>
                {"Round #"}
                {token.round.roundId}
              </List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>{token.round.contract?.title}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>
                {token.metadata.PRIZE ? "Prize " : ""}
                {getWinners(decodeNumbersToArr(token.metadata.NUMBERS), token.round.numbers || [])}
              </List.ItemText>
              <ListActions>
                <ListAction
                  onClick={handleView(LOTTERY_TICKETS_TOKENS_DIALOG_KEY, token, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <LotteryTokenDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${LOTTERY_TICKETS_TOKENS_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
